/**
 * Dates of the BI dashboards (CU-869fmhmx8). Local calendar days, never UTC: "today" is the user's today.
 * No imports: `node --test` runs it.
 */

const DAY = 864e5
const pad = n => String(n).padStart(2, '0')
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export const startOfDay = d => new Date(d.getFullYear(), d.getMonth(), d.getDate())
export const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n)
export const daysBetween = (a, b) => Math.round((startOfDay(b) - startOfDay(a)) / DAY)
export const minDate = (a, b) => (a <= b ? a : b)
export const maxDate = (a, b) => (a >= b ? a : b)

/** `Date` → `YYYY-MM-DD` */
export const toIso = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
/** `Date` → `YYYYMMDD` (what BI's form speaks) */
export const toCompact = d => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`

/** `YYYY-MM-DD` or `YYYYMMDD` → local `Date`, or `null` when it is not a calendar day */
export function fromIso(s) {
	const m = /^(\d{4})-?(\d{2})-?(\d{2})$/.exec(String(s ?? ''))
	if (!m) return null
	const d = new Date(+m[1], +m[2] - 1, +m[3])
	return d.getFullYear() === +m[1] && d.getMonth() === +m[2] - 1 && d.getDate() === +m[3] ? d : null
}

/** 16 Oct 2026 (`year: false` → 16 Oct) */
export const fmtDay = (d, year = true) => `${d.getDate()} ${MONTHS[d.getMonth()]}${year ? ' ' + d.getFullYear() : ''}`
/** Fri 16 Oct 2026 */
export const fmtWeekday = (d, year = true) => `${WEEKDAYS[d.getDay()]} ${fmtDay(d, year)}`
/** 1 Oct – 30 Nov 2026 (the year on the first day only when the two differ) */
export const fmtRange = (a, z) => `${fmtDay(a, a.getFullYear() !== z.getFullYear())} – ${fmtDay(z)}`

export const weekdayShort = d => WEEKDAYS[d.getDay()]
export const monthShort = d => MONTHS[d.getMonth()]
